const getters = {
    device: state => state.app.device,
    keepAlive: (state) => state.keekAlives
};

export default getters;